import { render, staticRenderFns } from "./userAdd.vue?vue&type=template&id=0ccc9f78&scoped=true&"
import script from "./userAdd.vue?vue&type=script&lang=js&"
export * from "./userAdd.vue?vue&type=script&lang=js&"
import style0 from "./userAdd.vue?vue&type=style&index=0&id=0ccc9f78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccc9f78",
  null
  
)

export default component.exports